export default "__VITE_ASSET__03186ba9__"